import classnames from "classnames";
import { useEffect, useRef } from "react";
import Button, { SIZE, STYLE, COLOR } from "components/Button";
import { ArrowBack } from "components/assets/Icons";

import styles from "./ContentHeader.module.scss";

const ContentHeader = ({
  title,
  details,
  buttonText,
  handleClickBack,
  onClick,
  state,
  className,
}) => {
  const refContentHeader = useRef();

  function setContentHeaderHeight() {
    if (typeof window === "object") {
      return document.documentElement.style.setProperty(
        "--content-header-height",
        `${refContentHeader.current?.offsetHeight}px`,
      );
    }
  }

  useEffect(() => {
    setContentHeaderHeight();
  }, [title]);

  return (
    <div className={classnames(styles.wrapper, className)} ref={refContentHeader}>
      {handleClickBack && (
        <button className={styles.button_back} onClick={handleClickBack}>
          <ArrowBack />
        </button>
      )}
      <h2 className={styles.title}>{title}</h2>
      {details && <span className={styles.details}>{details}</span>}
      {buttonText && (
        <Button
          size={SIZE.MIDDLE}
          style={state ? COLOR.NONE : STYLE.INFO}
          className={styles.button}
          onClick={onClick}
        >
          {buttonText}
        </Button>
      )}
    </div>
  );
};

export default ContentHeader;
